// Scenario that drives which collapsed sticky CTA button gets nudged and when.
export enum STICKY_CTA_NUDGE_SCENARIO {
    authLockedAnonymous = 'authLockedAnonymous',
    signedInNoWebAccess = 'signedInNoWebAccess',
    signedInHasWebAccess = 'signedInHasWebAccess',
}
